import type {NodeParameters} from "@cm/graph-v3"
import type {TemplateData} from "#template/compile-context"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import {TemplateNode} from "#template/template-node/template-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import type {TemplateLikeNode} from "#template/nodes/template-graph/fundamental"
import {templateLikeMarker} from "#template/nodes/template-graph/fundamental"
import {fundamentalLikeMarker} from "#template/role-markers"
import type {NodeEvaluator} from "#template/node-evaluator"

export abstract class TemplateGraphNode<out Parameters extends NodeParameters = NodeParameters, out ConstructorParameters extends NodeParameters = Parameters>
    extends TemplateNode<Parameters, ConstructorParameters>
    implements TemplateLikeNode
{
    get [templateLikeMarker]() {
        return true as const
    }
    get [fundamentalLikeMarker]() {
        return true as const
    }

    public abstract override get definition(): TemplateNodeDefinition<Parameters, ConstructorParameters>

    public abstract evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<TemplateData | null>
}
